import { css, Theme } from '@emotion/react'
import { buttonBaseClasses, buttonClasses } from '@mui/material'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  max-width: 1142px;
  padding: ${theme.spacing(1, 2, 1)};
`

export const headerSection = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${theme.spacing(4)};
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0, 0)};

  font-weight: 700;
`

export const hr = (theme: Theme) => css`
  height: 1px;

  background-color: ${theme.colors.backgroundOne};
`

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};

  margin: 0 auto;
  max-width: 754px;
`

export const studentWrapper = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(2)};
  align-items: center;
`

export const actionButtons = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(2)};
`

export const deleteButton = (theme: Theme) => css`
  flex: 0;

  &.${buttonClasses.root} {
    min-width: 112px;
    padding-left: ${theme.spacing(1.5)};
    color: ${theme.colors.red};

    :active {
      color: ${theme.colors.red};
    }

    :disabled {
      opacity: 0.8;

      color: ${theme.colors.red};
    }
  }
`

export const formActionButtonsRight = (theme: Theme) => css`
  display: flex;

  margin-left: auto;
  column-gap: ${theme.spacing(1.25)};

  & .${buttonBaseClasses.root} {
    width: 215px;
  }
`

export const actionButton = () => css`
  flex: 1;
`
